export const SEARCH_PATTERN_DELAY = 500
export const QUICK_SEARCH_PATTERN_DELAY = 700
